// packages/api-client/queries/contestsEditions/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createContestsEditionsQueries = (requests, queryClient) => ({
    useContestsEditionChecklist: (params, options = {}) => useQuery({
        queryKey: ["contests-edition-checklist", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.contestsEditionChecklist(params);
        },
        ...options,
    }),
    useContestsEditionStats: (params, options = {}) => useQuery({
        queryKey: ["contests-edition-stats", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.getContestsEditionStats(params);
        },
        ...options,
    }),
    useGetPublishingProgress: (params, options = {}) => useQuery({
        queryKey: ["contests-edition-publishing-progress", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.getPublishingProgress(params);
        },
        ...options,
    }),
    useCreateContestsEdition: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.createContestsEdition,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests-editions"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useFindContestsEdition: (params, options = {}) => useQuery({
        queryKey: ["contests-edition", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findContestsEdition(params);
        },
        ...options,
    }),
    useFinishContestsEdition: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.finishContestsEdition,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests-edition"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useGenerateContestsEditionReport: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.generateContestsEditionReport,
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
    useListContestsEditions: (params, options = {}) => useQuery({
        queryKey: ["contests-editions", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContestsEditions(params);
        },
        ...options,
    }),
    usePublishAllScoresheets: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.publishAllScoresheets,
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
    usePublishContestsEdition: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.publishContestsEdition,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests-edition"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUndoPublication: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.undoPublication,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests-edition"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateContestsEdition: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.updateContestsEdition,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests-edition"] });
            // switching the scoring mode unassigns scoresheet schemas of the other mode
            queryClient.invalidateQueries({ queryKey: ["contests-editions-styles"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDeleteContestsEdition: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.deleteContestsEdition,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests-editions"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useToggleGoogleSheetSync: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.toggleGoogleSheetSync,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests-edition"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useSyncGoogleSheet: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.syncGoogleSheet,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["contests-edition"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useInitializeContestsEditionPayment: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.initializeContestsEditionPayment,
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map